import React, { useEffect } from 'react';
import Grid from '../../../components/layout/grid/Grid';
import InputWithActionButton from './InputWithActionButton';
import CustomSelect from '../../../components/common/CustomSelect';
import CustomButton from '../../../components/common/CustomButton/CustomButton';
import CustomChip from '../../../components/common/CustomChip';
import { Check } from 'lucide-react';

const BasicDetailsForm = ({
  formik,
  onNext,
  handleVerifyClick,
  verifiedFields,
  verifyErrors,
  handleUploadClick,
  loadingStates,
  uploadedDocs,
}) => {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    setTouched,
    validateForm,
  } = formik;

  const handleUploadClickWrapper = (field) => {
    handleUploadClick(field);
  };

  useEffect(() => {
    const storedMobile = sessionStorage.getItem("skip_login_mobile_number");
    if (storedMobile && !values.mobile_number) {
      setFieldValue("mobile_number", storedMobile);
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'aadhar_card_number') {
      const digitsOnly = value.replace(/\D/g, '').slice(0, 12);
      setFieldValue(name, digitsOnly);
    } else {
      setFieldValue(name, value);
    }
  };

  const handleNextClick = async () => {
    await setTouched({
      name: true,
      mobile_number: true,
      email: true,
      aadhar_card_number: true,
      pan_card_number: true,
      qualification: true,
    });

    const formErrors = await validateForm();
    const cleanAadhaar = values.aadhar_card_number.replace(/\D/g, '');
    setFieldValue('aadhar_card_number', cleanAadhaar);

    if (formErrors && Object.keys(formErrors).length === 0) {
      onNext();
    }
  };

  const isFullyVerified = Boolean(verifiedFields.mobile && verifiedFields.email);

  console.log('verifiedFields', verifiedFields);
  console.log('isFullyVerified', isFullyVerified);
  console.log('touched.mobile_number', touched.mobile_number);
  

  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-semibold text-2xl">Basic Details</h2>
        <CustomChip
          variant={isFullyVerified ? "completed" : "default"}
          size="md"
          label={
            <span className="flex items-center">
              <Check className="w-4 h-4 mr-1" />
              Verified
            </span>
          }
        />
      </div>

      <Grid gap={24}>
        <Grid item xs={12} md={6}>
          <InputWithActionButton
            name="name"
            label="Full Name"
            placeholder="Enter full name"
            required
            value={values.name}
            onChange={handleInputChange}
            error={touched.name && errors.name}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <CustomSelect
            required
            name="qualification"
            label="Qualification"
            placeholder="Select qualification"
            menuList={[
              { label: '10th Passed', value: '10th Passed' },
              { label: '12th Passed', value: '12th Passed' },
              { label: 'U.Graduate', value: 'U.Graduate' },
              { label: 'P.Graduate', value: 'P.Graduate' },
            ]}
            error={touched.qualification && errors.qualification}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InputWithActionButton
            name="mobile_number"
            label="Mobile No."
            required
            placeholder="Enter the number"
            buttonLabel="Verify"
            onClick={() => handleVerifyClick('mobile', values.mobile_number)}
            verified={verifiedFields.mobile_number}
            helperText={verifyErrors.mobile_number || (touched.mobile_number && errors.mobile_number)}
            value={values.mobile_number}
            onChange={handleInputChange}
            error={touched.mobile_number && errors.mobile_number}
            loading={loadingStates.mobile_number}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InputWithActionButton
            name="email"
            label="Email ID"
            required
            placeholder="Enter email"
            buttonLabel="Verify"
            onClick={() => handleVerifyClick('email', values.email)}
            verified={verifiedFields.email}
            helperText={verifyErrors.email || (touched.email && errors.email)}
            value={values.email}
            onChange={handleInputChange}
            error={touched.email && errors.email}
            loading={loadingStates.email}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InputWithActionButton
            name="aadhar_card_number"
            label="Aadhar Card"
            required
            placeholder="Enter your Aadhaar (e.g., 1234 5678 9123)"
            buttonLabel="Upload"
            onClick={() => handleUploadClickWrapper('aadhar_card_number')}
            value={values.aadhar_card_number}
            onChange={handleInputChange}
            error={touched.aadhar_card_number && errors.aadhar_card_number}
            verified={uploadedDocs.aadhar_card_number}
            helperText={
              uploadedDocs.aadhar_card_number
                ? 'Aadhaar uploaded successfully'
                : touched.aadhar_card_number && errors.aadhar_card_number
            }
            loading={loadingStates.aadhar_card_number}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InputWithActionButton
            name="pan_card_number"
            label="Pan Card"
            required
            placeholder="Enter your PAN (e.g., ABCDE1234F)"
            buttonLabel="Upload"
            onClick={() => handleUploadClickWrapper('pan_card_number')}
            value={values.pan_card_number}
            onChange={handleInputChange}
            error={touched.pan_card_number && errors.pan_card_number}
            verified={uploadedDocs.pan_card_number}
            helperText={
              uploadedDocs.pan_card_number
                ? 'PAN uploaded successfully'
                : touched.pan_card_number && errors.pan_card_number
            }
            loading={loadingStates.pan_card_number}
          />
        </Grid>
      </Grid>

      <div className="flex justify-end gap-4 mt-6">
        <CustomButton
          type="reset"
          label="Reset"
          variant="default"
          onClick={() => formik.resetForm()}
        />
        <CustomButton
          type="button"
          label="Back"
          variant="outlined"
          onClick={() => { }}
        />
        <CustomButton
          type="button"
          label="Save & Next"
          variant="primary"
          onClick={handleNextClick}
          isLoading={formik.isSubmitting}
          disabled={formik.isSubmitting}
        />
      </div>
    </>
  );
};

export default BasicDetailsForm;
